export function validateNameUniqueness(elements: any, elementName: string) {
  if (elementName.trim().length) {
    return !elements.some((e: any) => e.name === elementName.trim());
  }
  return false;
}
